import { flattenMessages } from "./utils";

const messages = {  
  openIdStatusPage: {
    headline: "Authenticating",
    pleaseWait: "Please wait...",
    loading: "Loading",
    errorHeadline: "Authentication failed",
    errorBody: "Please try again.",
    retry: "Retry"
  },
  app: {
    title: "MIKE Data Link",
    registeredName: "Data Link",
    newRegisteredName: "Data Link",
    goToFWE: "Start Simulator"
  },
  supportEmail: {
    subject: "MIKE Data Link Request",
    body: "Please add relevant details about your request."
  },
  landingPage: {
    buttonText: "Go to login",
    header: "MIKE Data Link",
    linkLabel: "Unsure about how to access? ",
    linkText: "Contact us. "
  }, 
  createFolder: {
    name: "Name",
    description: "Description",
    createFolder: "Create folder",
    title: "Create folder"
  },
  common: {     
    dataset: "Dataset",      
    description: "Description",    
    editedAt: "Edited",
    folder: "Folder",    
    lastActivityAt: "Last activity",
    locationType: "Location type",    
    name: "Name",       
    project: "Project",
    projects: "Projects", 
    type: "Type",
    updatedAt: "Updated"
  },
  projectExplorer: {
    name: 'Name',
    type: 'Type',
    format: 'Format',
    srid: 'Projection system',
    updatedAt: 'Edited',
    na: 'N/A',
    epsg: 'EPSG',
    okButtonLabel: 'Select',
    cancelButtonLabel: 'Cancel',
    title: {
      selectMesh: 'Select mesh',
      selectMeshOutline: 'Select mesh outline',
      selectAOI: 'Select area of interest',
      selectExtraction: 'Select extraction (.zip)',
      selectBathymetry: 'Select bathymetry',
      selectPoints: 'Select points',
      selectShoreline: 'Select shoreline',
      selectBackground: 'Select background'
    }
  },
  platform: {
    replace: 'Replace from Cloud Admin',
    copy: 'Copy from Cloud Admin',
    cloud: 'Cloud'
  },
  desktop: {
    replace: 'Replace by upload',
    upload: 'Upload File',
    desktop: 'Desktop'
  }, 
};

export default flattenMessages(messages);
